




















import ProviderCategoryForm from '@/components/provider/category/ProviderCategoryForm.vue';
import ProviderUtils, { ProviderCategory } from '@/utils/ProviderUtils';

import Vue from 'vue';

export default Vue.extend({
  components: { ProviderCategoryForm },

  data(): {
    state: {
      valid: boolean;
      submit: boolean;
      errors?: any[];
    };
    item?: Partial<ProviderCategory>;
  } {
    return {
      state: {
        valid: false,
        submit: false,
        errors: undefined,
      },
      item: undefined,
    };
  },

  async mounted() {
    this.item = ProviderUtils.category.generateDefault();
  },

  methods: {
    async handleSubmit() {
      if (this.item) {
        try {
          this.state.errors = undefined;
          this.state.submit = true;
          (this.$refs.form as any).validate();
          this.item = await ProviderUtils.api.category.create(this.item);
          (this.$refs.form as any).resetValidation();
          this.$toast.push({
            text: this.$t('success.create', [
              this.$tc('provider.category.label'),
            ]),
            type: 'success',
          });
          this.$router.replace({ name: 'provider-category-list' });
        } catch (error) {
          this.$toast.push({
            text: this.$t('error.create', [
              this.$tc('provider.category.label'),
            ]),
            type: 'error',
          });
          this.state.errors = error; // TODO: handle errors
        } finally {
          this.state.submit = false;
        }
      }
    },
  },
});
